import styles from "./MainBottomRight.module.css";
import { tempWallet } from "../../../data/wallet";
import WalletTokenCard from "../tokenCard/WalletTokenCard";
import Divider from "../../misc/Divider/Divider";
const MainBottomRight = () => {

  

  return (
    <div className={styles.bottom_card}>
      <div className={styles.main_content}>
        <div className={styles.bottomCard_name}>
          <span className={styles.token_title}>Token</span>
          <span className={styles.token_value_title}>Value</span>
          <span className={styles.token_balance_title}>Balance</span>
        </div>
        <Divider/>
        <div className={styles.main_token_container}>
          
        {tempWallet &&
          tempWallet.map((token) => (
            <WalletTokenCard token={ token}/>
          ))}
   </div>
      </div>
    </div>
  );
};

export default MainBottomRight;
